var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "47px",
    height: "46px",
    viewBox: "0 0 47 46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Onboarding",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "12-Contacts---enable-notifications",
    transform: "translate(-695.000000, -104.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-notifications",
    transform: "translate(695.000000, 100.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.54464286,42.6785714 C3.97321429,39.0625 1.78571429,34.0625 1.78571429,28.5714286 C1.78571429,17.4553571 10.7589286,8.48214286 21.875,8.48214286 C32.9910714,8.48214286 41.9642857,17.4553571 41.9642857,28.5714286 C41.9642857,39.6875 32.9910714,48.6607143 21.875,48.6607143 L1.78571429,48.6607143 L7.54464286,42.6785714 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.875,50 L1.78571429,50 C1.25,50 0.758928571,49.6875 0.535714286,49.1964286 C0.3125,48.7053571 0.446428571,48.125 0.803571429,47.7232143 L5.71428571,42.6339286 C2.32142857,38.75 0.446428571,33.7946429 0.446428571,28.5714286 C0.446428571,16.7410714 10.0446429,7.14285714 21.875,7.14285714 C22.4553571,7.14285714 22.9910714,7.14285714 23.5714286,7.1875 C24.3303571,7.23214286 24.8660714,7.90178571 24.8214286,8.61607143 C24.7767857,9.375 24.1071429,9.91071429 23.3928571,9.86607143 C22.8571429,9.82142857 22.3660714,9.82142857 21.875,9.82142857 C11.5178571,9.82142857 3.125,18.2142857 3.125,28.5714286 C3.125,33.5267857 5.04464286,38.2142857 8.52678571,41.7410714 C9.01785714,42.2767857 9.0625,43.0803571 8.52678571,43.6160714 L4.95535714,47.3214286 L21.875,47.3214286 C32.2321429,47.3214286 40.625,38.9285714 40.625,28.5714286 C40.625,28.0803571 40.625,27.5892857 40.5803571,27.0982143 C40.5357143,26.3392857 41.0714286,25.7142857 41.8303571,25.6696429 C42.5446429,25.625 43.2142857,26.1607143 43.2589286,26.9196429 C43.3035714,27.4553571 43.3035714,28.0357143 43.3035714,28.5714286 C43.3035714,40.4017857 33.7053571,50 21.875,50 Z",
    id: "Path",
    fill: "#090B45"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#CA0B4A",
    transform: "translate(37.499598, 12.946652) rotate(-45.000000) translate(-37.499598, -12.946652) ",
    cx: 37.4995982,
    cy: 12.9466518,
    r: 8.9284858
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5,17.4107143 C36.7410714,17.4107143 36.1607143,16.8303571 36.1607143,16.0714286 L36.1607143,9.82142857 C36.1607143,9.0625 36.7410714,8.48214286 37.5,8.48214286 C38.2589286,8.48214286 38.8392857,9.0625 38.8392857,9.82142857 L38.8392857,16.0714286 C38.8392857,16.8303571 38.2589286,17.4107143 37.5,17.4107143 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4642857,25.8928571 L14.2857143,25.8928571 C13.5267857,25.8928571 12.9464286,25.3125 12.9464286,24.5535714 C12.9464286,23.7946429 13.5267857,23.2142857 14.2857143,23.2142857 L29.4642857,23.2142857 C30.2232143,23.2142857 30.8035714,23.7946429 30.8035714,24.5535714 C30.8035714,25.3125 30.2232143,25.8928571 29.4642857,25.8928571 Z",
    id: "Path",
    fill: "#B2C1DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7678571,33.9285714 L14.2857143,33.9285714 C13.5267857,33.9285714 12.9464286,33.3482143 12.9464286,32.5892857 C12.9464286,31.8303571 13.5267857,31.25 14.2857143,31.25 L22.7678571,31.25 C23.5267857,31.25 24.1071429,31.8303571 24.1071429,32.5892857 C24.1071429,33.3482143 23.5267857,33.9285714 22.7678571,33.9285714 Z",
    id: "Path",
    fill: "#B2C1DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9107143,33.9285714 L29.4642857,33.9285714 C28.7053571,33.9285714 28.125,33.3482143 28.125,32.5892857 C28.125,31.8303571 28.7053571,31.25 29.4642857,31.25 L29.9107143,31.25 C30.6696429,31.25 31.25,31.8303571 31.25,32.5892857 C31.25,33.3482143 30.6696429,33.9285714 29.9107143,33.9285714 Z",
    id: "Path",
    fill: "#B2C1DF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotifications);
export default __webpack_public_path__ + "static/media/icon-notifications.4c4f452430b6472fa27ce9226da876d3.svg";
export { ForwardRef as ReactComponent };